module.exports = __webpack_public_path__ + "img/mobile_background_section5.98ce1df4.png";